/* eslint-disable react/forbid-elements */
import * as React from 'react';

export const WalkIcon: React.FunctionComponent<object> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
    {/*tslint:disable-next-line:max-line-length*/}
    <path
      fill="#7A7A7A"
      fillRule="evenodd"
      d="M3.281 1.795a.889.889 0 0 0 .875-.898A.889.889 0 0 0 3.281 0a.889.889 0 0 0-.875.897c0 .494.394.898.875.898zM1.662 3.32L.439 9.647h.918l.788-3.59.918.898v2.692h.876V6.282l-.92-.897.263-1.347A3.17 3.17 0 0 0 5.687 5.16v-.897a2.142 2.142 0 0 1-1.88-1.077l-.438-.718c-.175-.27-.438-.449-.744-.449-.131 0-.219.045-.35.045L0 3.051v2.11h.875V3.634l.788-.314z"
    />
  </svg>
);
